import React, { useState, useEffect, useContext } from 'react';
import { Grid, Button, Dialog, Tooltip, DialogTitle, Card, CardContent, CardActionArea, Menu, IconButton, MenuItem, Typography, Box, Tabs, Tab, DialogContent, TextField, DialogActions } from '@mui/material';
import { Link } from 'react-router-dom';
import { useMediaQuery } from 'react-responsive';

import { FaList, FaRegKeyboard, FaRegListAlt } from "react-icons/fa";
import { MdOutlineReportProblem } from "react-icons/md";
import { SlCalculator } from "react-icons/sl";
import { FaRegBookmark } from "react-icons/fa";
import { IoIosCloseCircleOutline } from "react-icons/io";
import "../../../SFComponents/SFNavbar/style.css"
import KeyBoardInstruction from '../../../../components/KeyBoardInstruction';
import Calculator from '../../../../components/Calculator';
import Draggable from 'react-draggable';
import { RxHamburgerMenu } from "react-icons/rx";
import { HiDotsVertical } from "react-icons/hi";
import { isBrowser, isMobile, isTablet } from 'react-device-detect';
import moment from 'moment';
import { AppProperties, IsPublicSite } from '../../../../common/functions';
import ApiRequestService from '../../../../components/ApiRequestService';
import { NotificationManager } from 'react-notifications';
import RegisterAnonymousUser from './RegisterAnonymousUser';
import { AppContext } from '../../../../AppContext';

const SFTakequizNavbar = (props) => {

  const isMobile = useMediaQuery({ query: `(max-width: 760px)` });

  const appProperties = AppProperties();

  const appContext = useContext(AppContext);

  console.debug("currentUserData", appProperties.currentUserData)

  const params = new URLSearchParams(props.location.search);
  const quizName = decodeURIComponent(params.get("quiz_name"));

  const [showKeyboardShortcuts, setShowKeyboardShortcuts] = useState(false);
  const [showCalculator, setShowCalculator] = useState(false);
  const [tabKeyPressed, setTabKeyPressed] = useState(false);
  const [menuAnchorEl, setMenuAnchorEl] = useState(null);

  const openMenu = Boolean(menuAnchorEl);
  const handleMenuClick = (event) => {
    setMenuAnchorEl(event.currentTarget);
  };

  const handleKeyDown = (event) => {
    if (event.key === "Tab" && !tabKeyPressed) {
      setShowKeyboardShortcuts(true);
      setTabKeyPressed(true); // Ensure the dialog only shows on the first Tab press
    }
  };

  const handleClose = () => {
    setMenuAnchorEl(null);
  };

  const closeKeyboardShortcut = () => {
    setShowKeyboardShortcuts(false)
  }
  const closeCalculator = () => {
    setShowCalculator(false)
  }

  return (
    <div className='sf-navbar' onKeyDown={handleKeyDown}>
      <Grid container style={{ height: '100%', position: 'relative' }}>

        {isMobile ?
          <Grid item xs={2} >
            <IconButton
              className='w-100'
              onClick={handleMenuClick}
              aria-controls={openMenu ? 'takequiz-menu' : undefined}
              aria-haspopup="true"
              aria-expanded={openMenu ? 'true' : undefined}
            >
              <HiDotsVertical color='#bb0000' fontSize={32} />
            </IconButton>
            <Menu
              className='sf-takequiz-menu'
              disableScrollLock={true}
              id="takequiz-menu"
              anchorEl={menuAnchorEl}
              open={openMenu}
              onClose={handleClose}
              slotProps={{
                paper: {
                  style: {
                    width: 160,
                  }
                }
              }}
              MenuListProps={{
                'aria-labelledby': 'menu',
              }}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
              }}
              transformOrigin={{
                vertical: 'top',
                horizontal: 'center',
              }}
            >
              {props.showFreeChoice && props.courseID !== -1 ?
                <MenuItem className='sf-nav-menu-item' onClick={props.onShowCategorySelection}>
                  Category List
                </MenuItem>
                : null}
              <MenuItem className='sf-nav-menu-item' onClick={() => setShowKeyboardShortcuts(true)}>Shortcut Keys</MenuItem>
              {
                props.showCalculator ? <MenuItem className='sf-nav-menu-item' onClick={() => setShowCalculator(!showCalculator)}>Calculator</MenuItem>
                  : null
              }

            </Menu>
          </Grid>
          : null}
        <Grid item xs={isMobile ? 8 : 6}>
          <div style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center', height: '100%' }}>
            <div>
              <div className='font-weight-bold' style={{
                fontSize: isMobile ? 16 : 20
              }}>
                <span style={{ color: '#BA0C2F' }}>Assignment</span>
                {/* {props.onePageMode ? 
                                    <span> - {quizName} 
                                        <Typography className='d-inline-block ml-2' fontSize={12}>
                                            {props.lastSavedAt ? `Last saved at ${props.lastSavedAt}` : (
                                                props.onePageTestSaving ? "Saving..." : `Quiz saved at ${moment().format("h:mm a")}`
                                            )}
                                        </Typography>
                                    </span>
                                : null} */}
              </div>
              {props.practiceCount > 0 ?
                <div>
                  (This is a nongraded practice attempt. Your grade will not be affected by this attempt)
                </div>
                : null}
              {/* {props.courseName && props.courseName !== "null" ?
                                <div style={{
                                    fontSize: isMobile ? 12 : 16
                                }}>{props.courseName}</div>
                                : ""} */}

            </div>
            {/* Show register btn here so when anonymous user practices in public site they can register and save the result */}
            {appContext.isPublicSite && appProperties?.currentUserData?.USER_NAME?.includes("anonymous") ?
              <div
                style={{
                  marginLeft: "1rem",
                }}
                className='register-track-btn-container mt-2'
              >
                <RegisterAnonymousUser
                  btnContent={<div className='register-track-btn py-1'>
                    <div className='text-center text-align-center w-100'>Register & Track Progress</div>
                    <div>
                      <small>
                        Create an account to save your progress, track achievements, and access personalized analytics for FREE
                      </small>
                    </div>
                  </div>}
                />
              </div>

              : null}

          </div>
        </Grid>

        {!isMobile ?

          <Grid item xs={6} style={{ height: '100%' }} display={'flex'} justifyContent={'flex-end'} gap={2}>
            {props.showFreeChoice && props.courseID !== -1 ?
              <Button onClick={props.onShowCategorySelection}>
                <div className='d-flex flex-column'>
                  <div className='mb-2'><FaRegListAlt fontSize={20} /></div>
                  <div>
                    Category List
                  </div>
                </div>
              </Button>
              : null}
            <Button onClick={() => setShowKeyboardShortcuts(true)}>
              <div className='d-flex flex-column'>
                <div className='mb-2'><FaRegKeyboard fontSize={20} /></div>
                <div>
                  Shortcut Keys
                </div>
              </div>
            </Button>
            <Button className='d-none'>
              <div className='d-flex flex-column'>
                <div className='mb-2'><MdOutlineReportProblem fontSize={20} /></div>
                <div>
                  Report
                </div>
              </div>
            </Button>
            {props.showCalculator ?
              <Button onClick={() => setShowCalculator(!showCalculator)}>
                <div className='d-flex flex-column'>
                  <div className='mb-2'><SlCalculator fontSize={20} /></div>
                  <div>
                    Calculator
                  </div>
                </div>
              </Button>
              : null}
            <Button className='d-none'>
              <div className='d-flex flex-column'>
                <div className='mb-2'><FaRegBookmark fontSize={20} /></div>
                <div>
                  Bookmark
                </div>
              </div>
            </Button>
            {props?.isAnonymous ? null :
              <Tooltip title="Save & Exit">
                <Button onClick={props.onSaveAndExit}>
                  <div className='sf-nav-link'>
                    <IoIosCloseCircleOutline fontSize={40} />
                  </div>
                </Button>
              </Tooltip>
            }
          </Grid>

          : null}

        {isMobile ?
          <Grid item xs={2}>
            <Tooltip title="Save & Exit">
              <Button onClick={props.onSaveAndExit}>
                <div className='sf-nav-link'>
                  <IoIosCloseCircleOutline fontSize={40} />
                </div>
              </Button>
            </Tooltip>
          </Grid>
          : null}

      </Grid>

      {showKeyboardShortcuts ?
        <KeyboardShortcut
          currentQuestionType={props?.currentQuestionType}
          closeKeyboardShortcut={closeKeyboardShortcut} /> : null}
      {showCalculator ?
        <Draggable>
          <Card style={{ zIndex: '9999 !important', width: 'fit-content' }}>
            <div className='w-100 text-align-center bg-secondary text-white py-2' style={{ cursor: 'move' }}>Click here to drag</div>
            <CardContent>
              <Calculator closeCalculator={closeCalculator} />
            </CardContent>
            <center className='mb-2'>
              <Button size='medium' variant='contained' color='primary' style={{ color: '#fff' }}
                onTouchStart={closeCalculator}
                onClick={closeCalculator}>Close</Button>
            </center>
          </Card>
        </Draggable>
        : null}
    </div>
  );
}



const KeyboardShortcut = (props) => {
  const [activeTab, setActiveTab] = useState(0);
  const [openShortcutMenu, setOpenShortcutMenu] = useState(false);
  const [shortcutAnchor, setShortcutAnchor] = useState(null);

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  const handleShortcutMenuClick = (event) => {
    setShortcutAnchor(event.currentTarget);
    setOpenShortcutMenu(true);
  };
  const handleShortcutClose = () => {
    setOpenShortcutMenu(false);
    setShortcutAnchor(null);
  };

  const handleShortcutMenuOptionClick = (value) => {
    setOpenShortcutMenu(false);
    setActiveTab(value)
  };

  useEffect(() => {
    if (props?.currentQuestionType === 3) {
      //vector question type
      setActiveTab(2)
    } else if (props?.currentQuestionType === 4) {
      //Reasoning chain question type
      setActiveTab(3)
    } else if (props?.currentQuestionType === 0) {
      //RStanfdard question type
      setActiveTab(1)
    }
  }, [])
  return (
    <Dialog
      id="keyboard-shortcuts"
      open={true}
      fullWidth
      maxWidth="md"
      onKeyDown={(evt) => {
        if (evt.key === "Escape" || evt.key === "Esc" || evt.keyCode === 27) {
          props.closeKeyboardShortcut();
        }
      }}
    >
      <Box
        display="flex"
        alignItems="center"
        justifyContent={isMobile ? "space-between" : "start"}
        paddingX={3}
        paddingY={1}

      >
        <DialogTitle style={{ margin: 0, padding: 0 }}>Keyboard Shortcuts</DialogTitle>
        {isMobile ? (
          <Grid item xs={2}>
            <IconButton
              className="w-100"
              onClick={handleShortcutMenuClick}
              aria-controls={openShortcutMenu ? 'takequiz-menu' : undefined}
              aria-haspopup="true"
              aria-expanded={openShortcutMenu ? 'true' : undefined}
            >
              <HiDotsVertical color="#bb0000" fontSize={32} />
            </IconButton>
            <Menu
              className="sf-takequiz-menu"
              disableScrollLock={true}
              id="takequiz-menu"
              anchorEl={shortcutAnchor}
              open={openShortcutMenu}
              onClose={handleShortcutClose}
              slotProps={{
                paper: {
                  style: {
                    width: 160,
                  },
                },
              }}
              MenuListProps={{
                'aria-labelledby': 'menu',
              }}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
              }}
              transformOrigin={{
                vertical: 'top',
                horizontal: 'center',
              }}
            >
              <MenuItem className="sf-nav-menu-item" onClick={() => handleShortcutMenuOptionClick(0)}>
                General
              </MenuItem>
              <MenuItem className="sf-nav-menu-item" onClick={() => handleShortcutMenuOptionClick(1)}>
                Multiple Choice
              </MenuItem>
              <MenuItem className="sf-nav-menu-item" onClick={() => handleShortcutMenuOptionClick(2)}>
                Vectors
              </MenuItem>
              <MenuItem className="sf-nav-menu-item" onClick={() => handleShortcutMenuOptionClick(3)}>
                Reasoning Chain
              </MenuItem>
            </Menu>
          </Grid>
        ) : (
          <Tabs
            value={activeTab}
            onChange={handleTabChange}
            indicatorColor="primary"
            textColor="primary"
            style={{ marginLeft: '5%' }}
          >
            <Tab label="General" />
            <Tab label="Multiple Choice" />
            <Tab label="Vectors" />
            <Tab label="Reasoning Chain" />
          </Tabs>
        )}
      </Box>

      {/* Tab Content */}
      {activeTab === 0 && (
        <Grid container spacing={isMobile ? 1 : 2} padding={isMobile ? 2 : 3}>
          <Grid item md={6} xs={12}>
            <KeyBoardInstruction
              Keys={["?"]}
              Instruction={"Toggle keyboard shortcuts help dialog"}
            />
            <KeyBoardInstruction
              Keys={["Tab"]}
              Instruction={"Change field selection"}
            />
            <KeyBoardInstruction
              Keys={["Shift", "Tab"]}
              Instruction={"Go to previous field selection"}
            />

          </Grid>
        </Grid>
      )}
      {/* MCQ Question */}
      {activeTab === 1 && (
        <Grid container spacing={isMobile ? 1 : 2} padding={isMobile ? 2 : 3}>
          <Grid item md={6} xs={12}>
            <KeyBoardInstruction
              Keys={["F1"]}
              Instruction={"Toggle Help Text"}
            />
            <KeyBoardInstruction
              Keys={["Space"]}
              Instruction={"Change radio button selection"}
            />
          </Grid>
          {/* <Grid item md={6} xs={12}>
              <KeyBoardInstruction
                Keys={["Shift", "↑"]}
                Instruction={"Move vector y+ axis"}
              />
              <KeyBoardInstruction
                Keys={["Shift", "↓"]}
                Instruction={"Move vector y- axis"}
              />
              <KeyBoardInstruction
                Keys={["Shift", "→"]}
                Instruction={"Move vector x+ axis"}
              />
              <KeyBoardInstruction
                Keys={["Shift", "←"]}
                Instruction={"Move vector x- axis"}
              />
            </Grid> */}
        </Grid>
      )}

      {/* Vector Question */}
      {activeTab === 2 && (
        <Grid container spacing={isMobile ? 1 : 2} padding={isMobile ? 2 : 3}>
          <Grid item md={6} xs={12}>
            <KeyBoardInstruction
              Keys={["F1"]}
              Instruction={"Toggle Vector Help Text"}
            />
            <KeyBoardInstruction
              Keys={["↑"]}
              Instruction={"Move vector head y+ axis"}
            />
            <KeyBoardInstruction
              Keys={["↓"]}
              Instruction={"Move vector head y- axis"}
            />
            <KeyBoardInstruction
              Keys={["→"]}
              Instruction={"Move vector head x+ axis"}
            />
            <KeyBoardInstruction
              Keys={["←"]}
              Instruction={"Move vector head x- axis"}
            />
          </Grid>
          <Grid item md={6} xs={12}>
            <KeyBoardInstruction
              Keys={["Shift", "↑"]}
              Instruction={"Move vector y+ axis"}
            />
            <KeyBoardInstruction
              Keys={["Shift", "↓"]}
              Instruction={"Move vector y- axis"}
            />
            <KeyBoardInstruction
              Keys={["Shift", "→"]}
              Instruction={"Move vector x+ axis"}
            />
            <KeyBoardInstruction
              Keys={["Shift", "←"]}
              Instruction={"Move vector x- axis"}
            />
          </Grid>
        </Grid>
      )}

      {/* Reasoning Chain Question */}
      {activeTab === 3 && (
        <Grid container spacing={isMobile ? 1 : 2} padding={isMobile ? 1 : 3}>
          <Grid item md={6} xs={12}>
            <KeyBoardInstruction Keys={["→"]} Instruction={"Go to the submenu inside the current item"} />
            <KeyBoardInstruction Keys={["←"]} Instruction={"Return to the main menu from the submenu"} />
            <KeyBoardInstruction Keys={["↑"]} Instruction={"Move to the previous item in the menu"} />
            <KeyBoardInstruction Keys={["↓"]} Instruction={"Move to the next item in the menu"} />
          </Grid>
          <Grid item md={6} xs={12}>
            <KeyBoardInstruction Keys={["Tab"]} Instruction={"Change field selection"} />
            <KeyBoardInstruction Keys={["Shift", "Tab"]} Instruction={"Go to previous field selection"} />
            <KeyBoardInstruction Keys={["Enter"]} Instruction={"Confirm selection and proceed"} />
          </Grid>
        </Grid>
      )}

      <center className="my-5">
        <Button
          variant="contained"
          color="primary"
          onClick={props.closeKeyboardShortcut}
        >
          Close
        </Button>
      </center>
    </Dialog>
  )
}

export default SFTakequizNavbar;
